import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Builds click handlers for the landing page's in-page section anchors
// (#features, #pricing, #trust) so they still work from NavBar/Footer when
// rendered on a different route (e.g. /contact, /terms) — plain <a href="#...">
// only scrolls if the target id already exists on the current page. When
// already on the (language-prefixed) landing page, scroll directly;
// otherwise navigate to "/:lang#hash" and let Landing's own hash effect
// (see Landing.jsx) scroll once it has mounted.
export default function useSectionNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  return (hash) => (e) => {
    e.preventDefault();
    // trailing slash ignored: the server redirects /fr to /fr/ (prerendered index.html)
    if (location.pathname.replace(/\/+$/, '') === `/${i18n.language}`) {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/${i18n.language}#${hash}`);
    }
  };
}
